<div class="modal-header" style="background: #1e1e1e; border-bottom: 1px solid rgba(255,255,255,0.1); padding: 16px 20px;">
  <h5 class="modal-title" style="color: #fff; font-size: 16px; font-weight: 600; margin: 0;">
    <i class="fas fa-wifi-slash me-2" style="color: #f87171;"></i>
    Pending Offline Changes
  </h5>
  <button type="button" class="btn-close btn-close-white" (click)="modalRef.hide()"></button>
</div>

<div class="modal-body" style="background: #1e1e1e; padding: 16px 20px; max-height: 75vh; overflow-y: auto;">
  @if (groups.length === 0) {
    <p style="color: #9ca3af; text-align: center; margin: 24px 0;">No pending changes.</p>
  }

  @for (group of groups; track group.method) {
    <div style="margin-bottom: 28px;">
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px;">
        <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%;" [style.background]="methodColor(group.method)"></span>
        <span style="color: #e0e0e0; font-size: 13px; font-weight: 600;">
          {{ group.label }}
          <span style="color: #9ca3af; font-weight: 400; margin-left: 6px;">({{ group.ops.length }})</span>
        </span>
      </div>

      <div style="overflow-x: auto;">
        <table style="width: 100%; border-collapse: collapse; font-size: 11px;">
          <thead>
            <tr style="border-bottom: 1px solid rgba(255,255,255,0.12); background: rgba(255,255,255,0.04);">
              <th style="color: #9ca3af; font-weight: 500; text-align: left; padding: 6px 10px; white-space: nowrap;">Endpoint</th>
              <th style="color: #9ca3af; font-weight: 500; text-align: left; padding: 6px 10px; white-space: nowrap;">Queued</th>
              <th style="color: #9ca3af; font-weight: 500; text-align: left; padding: 6px 10px; white-space: nowrap;">Retries</th>
              @for (col of group.columns; track col) {
                <th style="color: #9ca3af; font-weight: 500; text-align: left; padding: 6px 10px; font-family: monospace; white-space: nowrap;">{{ col }}</th>
              }
              @if (group.columns.length === 0) {
                <th style="color: #9ca3af; font-weight: 500; padding: 6px 10px;">Notes</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (op of group.ops; track op.id) {
              <tr style="border-bottom: 1px solid rgba(255,255,255,0.05);">
                <td style="padding: 6px 10px; vertical-align: top; min-width: 160px;">
                  <div style="color: #e0e0e0; font-weight: 600;">{{ resourceLabel(op.url) }}</div>
                  <div style="color: #6b7280; font-family: monospace; font-size: 10px;">{{ formatUrl(op.url) }}</div>
                  @if (op.tempId) {
                    <div style="color: #9ca3af; font-size: 10px;">temp: {{ op.tempId }}</div>
                  }
                  @if (op.needsTransactionId) {
                    <div style="color: #facc15; font-size: 10px;"><i class="fas fa-clock me-1"></i>awaiting txn #</div>
                  }
                </td>
                <td style="padding: 6px 10px; color: #9ca3af; vertical-align: top; white-space: nowrap;">
                  <div>{{ formatDate(op.timestamp) }}</div>
                  <div style="color: #6b7280; font-size: 10px;">{{ formatTime(op.timestamp) }}</div>
                </td>
                <td style="padding: 6px 10px; vertical-align: top; text-align: center;">
                  @if (op.retryCount > 0) {
                    <span style="color: #f87171;">{{ op.retryCount }}x</span>
                  } @else {
                    <span style="color: #6b7280;">&#8212;</span>
                  }
                </td>
                @for (col of group.columns; track col) {
                  <td style="padding: 6px 10px; color: #e0e0e0; vertical-align: top; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ getCell(op, col) }}
                  </td>
                }
                @if (group.columns.length === 0) {
                  <td style="padding: 6px 10px; color: #6b7280; font-style: italic; vertical-align: top;">No payload</td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>

<div class="modal-footer" style="background: #1e1e1e; border-top: 1px solid rgba(255,255,255,0.1); padding: 12px 20px; display: flex; align-items: center;">
  <span style="color: #9ca3af; font-size: 12px; flex: 1;">
    Changes will sync automatically when your connection is restored.
  </span>
  <button type="button" class="btn btn-sm btn-secondary" (click)="modalRef.hide()">Close</button>
</div>
